// Application
import { tracking } from '../tracking'

export const Analytics = {
    RecoverPasswordSteps: {
        FederalTaxId: {
            event: tracking.EVENT.RESET_PASSWORD_FUNNEL_STEPS,
            steps: tracking.STEPS.RESET_PASSWORD_CPF,
        },
        NewPassword: {
            event: tracking.EVENT.FUNNEL_STEP,
            steps: tracking.STEPS.RESET_PASSWORD_NOVA_SENHA,
            name: tracking.RESET_PASSWORD_SUCESSO.NAME,
        },
        NewPasswordOnSubmit: {
            event: tracking.EVENT.FUNNEL_STEP,
            href: tracking.RESET_PASSWORD_SUCESSO.HREF,
        },
        SelectContact: {
            event: tracking.EVENT.FUNNEL_STEP,
            funnel: tracking.FUNNEL_RESET_PASSWORD,
        },
        ValidateToken: {
            event: tracking.EVENT.FUNNEL_STEP,
            funnel: tracking.FUNNEL_RESET_PASSWORD_TOKEN,
        },
    },
    RecoverPasswordPageView: {
        FederalTaxId: {
            event: tracking.EVENT.VPAGEVIEW,
            href: tracking.STEPS.RESET_PASSWORD_CPF,
        },
        NewPassword: {
            event: tracking.EVENT.VPAGEVIEW,
            href: tracking.STEPS.RESET_PASSWORD_NOVA_SENHA,
        },
        NewPasswordOnSubmit: {
            event: tracking.EVENT.VPAGEVIEW,
            href: tracking.RESET_PASSWORD_SUCESSO.HREF,
        },
        SelectContact: {
            event: tracking.EVENT.VPAGEVIEW,
            href: tracking.STEPS.RESET_PASSWORD_CONTACT,
        },
        ValidateToken: {
            event: tracking.EVENT.VPAGEVIEW,
            href: tracking.STEPS.RESET_PASSWORD_TOKEN,
        },
    },
    Negative: {
        RecoverPassword: {
            event: tracking.EVENT.NEGATIVE_RESET,
        },
    },
    ActivateAccountStep: {
        NewPassword: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            steps: tracking.STEPS.ACTIVATE_ACCOUNT_SENHA,
        },
        SelectContact: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            steps: tracking.STEPS.ACTIVATE_ACCOUNT_SELECT_CONTACT,
        },
        ValidateToken: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            steps: tracking.STEPS.ACTIVATE_ACCOUNT_TOKEN,
        },
    },
    ActivateAccountPageview: {
        NewPassword: {
            event: tracking.EVENT.VPAGEVIEW,
            href: tracking.STEPS.ACTIVATE_ACCOUNT_SENHA,
        },
        SelectContact: {
            event: tracking.EVENT.VPAGEVIEW,
            href: tracking.STEPS.ACTIVATE_ACCOUNT_SELECT_CONTACT,
        },
        ValidateToken: {
            event: tracking.EVENT.VPAGEVIEW,
            href: tracking.STEPS.ACTIVATE_ACCOUNT_TOKEN,
        },
    },
    SignUp: {
        BiologicalSexMount: {
            event: tracking.EVENT.CADASTRO_FUNEL_STEPS,
            steps: tracking.STEPS.NEW_CADASTRO_SEXO,
        },
        BiologicalSexMountMDM: {
            event: tracking.EVENT.CADASTRO_FUNEL_STEPS,
            steps: tracking.STEPS.MDM_CADASTRO_SEXO,
        },
        CreatePasswordMount: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
        },
        NewRegisterUser: {
            event: tracking.EVENT.CADASTRO_FUNEL_STEPS,
            steps: tracking.STEPS.NEW_CADASTRO,
        },
        MDMRegisterUser: {
            event: tracking.EVENT.CADASTRO_FUNEL_STEPS,
            steps: tracking.STEPS.MDM_CADASTRO,
        },
        EmailMount: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
            steps: tracking.STEPS.NEW_CADASTRO_EMAIL,
        },
        PersonalDataMount: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
            steps: tracking.STEPS.NEW_CADASTRO_DADOS_PESSOAIS,
        },
        PhoneMount: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
            steps: tracking.STEPS.NEW_CADASTRO_TELEFONE,
        },
        PostalCode: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
            steps: tracking.STEPS.NEW_CADASTRO_CEP,
        },
        PostalCodeOpenModal: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
            steps: tracking.STEPS.REVISAO_DADOS,
        },
        SelectContactMount: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
            steps: tracking.STEPS.MDM_ATIVE_CADASTRO,
        },
        SelectContactOpenModal: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
            steps: tracking.STEPS.MDM_DADOS_INCORRETOS,
        },
        ValidateTokenMount: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
        },
        WelcomeMount: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
            steps: tracking.STEPS.MDM_BOAS_VINDAS,
        },
        ValidateTokenIncorrectData: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
            steps: tracking.STEPS.MDM_DADOS_INCORRETOS,
        },
        DivergentRegisterCIP: {
            event: tracking.EVENT.NEGATIVA_LOGIN,
            reason: tracking.REASON,
            access: 'Cip',
        },
        DivergentRegisterCPF: {
            event: tracking.EVENT.NEGATIVA_LOGIN,
            reason: tracking.REASON,
            access: 'Cpf',
        },
        DivergentRegister: {
            event: tracking.EVENT.CADASTRO_FUNNEL_STEPS,
            steps: tracking.STEPS.CADASTRO_DIVERGENTE,
        },
    },
    ActivateAccountCipOrphan: {
        Cpf: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.ACTIVATE_ACCOUNT_CIP_CPF,
        },
        // Cadastro Divergente CIP
        ModalInvalid: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.ACTIVATE_ACCOUNT_CIP_MODAL_INVALID,
        },
        // Cadastro Divergente FAP
        ModalInvalidFAP: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.ACTIVATE_ACCOUNT_FAP_MODAL_INVALID,
        },
        // Tem conta Nav Dasa
        ModalAccountNav: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.ACTIVATE_ACCOUNT_CIP_MODAL_ACCOUNT_NAV,
        },
        LoginAccountNav: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.ACTIVATE_ACCOUNT_CIP_LOGIN_ACCOUNT_NAV,
        },
        MdmAccountPassword: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.MDM_PASSWORD,
        },
        MdmAccountContact: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.MDM_CONTACT,
        },
        MdmAccountToken: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.MDM_TOKEN,
        },
        NewAccountBiologicSex: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.NEW_SEXO,
        },
        NewAccountCreatePassword: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.NEW_SENHA,
        },
        NewAccountPhone: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.NEW_CONTATO,
        },
        NewValidateToken: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.NEW_TOKEN,
        },
        RegisterExamesLogin: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.ACTIVATE_ACCOUNT_CIP_MANUAL,
        },
        RegisterExamesNewSignUp: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.ACTIVATE_ACCOUNT_CIP_NEW_MANUAL,
        },
        RegisterExamesMDMSignUp: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_FUNNEL_STEPS,
            path: tracking.PATH.CIP,
            steps: tracking.STEPS.ACTIVATE_ACCOUNT_CIP_MDM_MANUAL,
        },
        ActivateAccountComplete: {
            event: tracking.EVENT.ACTIVATE_ACCOUNT_SUCCESS,
            href: tracking.ACTIVATE_ACCOUNT_SUCCESS.HREF,
            path: tracking.PATH.CIP,
            user: tracking.ACTIVATE_ACCOUNT_SUCCESS.USER,
        },
    },
    AjudaLogin: {
        event: tracking.AJUDA_LOGIN.EVENT,
        href: tracking.AJUDA_LOGIN.HREF,
    },
}

export const LoginsTypes = {
    DATA: {
        LOGIN: {
            USER_TYPE: {
                FAP_ORPHAN: 'FAP',
                CIP_ORPHAN: 'Cip_Orfa',
                COMPLETE: 'Completo',
                INCOMPLETE: 'Mdm_Incompleto',
                UNDERAGE: 'Dependente',
                INVALID_CIP_MDM: 'Cadastro_Divergente',
            },
            ACCESS: {
                CIP_LAB: 'Cip_lab',
                CIP_NLAB: 'Cip_nLab',
                FAP_LAB: 'Fap_lab',
                FAP_NLAB: 'Fap_nLab',
            },
        },
        PATH: {
            CIP_ORPHAN: 'Cip_Orfa',
        },
        STEPS: {
            DETAILS: 'Detalhes',
        },
    },
    EVENTS: {
        LOGIN_SUCCESS: 'login_success',
        ATIVACAO_CIP_ORPHAN: 'Ativacao_Cadastro_Steps',
        LOGIN_FAILURE: 'login_failure',
    },
    FUNNELS: {
        LOGIN_FASEADO: 'login_faseado',
        CADASTRO_WEB: 'cadastro_web',
        RECOVER_PASSWORD_LOGIN: 'recuperar_senha',
    },
}

export * from './signUp'
